{
  "promoter": {
    "home": {
      "greeting": "Hola, {{name}}",
      "programLine": "El {{percent}} % de la suscripción pagada de cada agencia durante sus primeros {{days}} días. Las comisiones quedan retenidas {{hold}} días antes de poder pagarse.",
      "suspended": "Tu cuenta de promotor está en pausa. No se están sumando comisiones nuevas.",
      "suspendedReason": "Motivo: {{reason}}",
      "suspendedNegativeBalance": "dinero que ya se te pagó fue devuelto (un reembolso o una disputa), así que tu saldo está por debajo de cero.",
      "money": {
        "title": "Tu dinero",
        "available": "Disponible",
        "held": "Retenido",
        "paid": "Pagado a ti",
        "request": "Solicitar pago",
        "requesting": "Solicitando…",
        "requested": "Pago solicitado. Lo revisaremos pronto.",
        "reasons": {
          "w9_required": "Sube un W-9 y espera a que lo aceptemos para solicitar un pago.",
          "request_pending": "Tu solicitud de pago está pendiente de revisión.",
          "nothing_available": "Todavía no hay nada disponible para pagar."
        }
      },
      "share": {
        "title": "Comparte tu enlace",
        "body": "Las agencias que creen su cuenta de Coreway desde este enlace quedan asignadas a ti.",
        "code": "Tu código",
        "link": "Tu enlace",
        "qr": "Código QR de tu enlace",
        "downloadQr": "Descargar QR"
      },
      "agencies": {
        "title": "Tus agencias",
        "empty": "Ninguna agencia se ha unido con tu enlace todavía.",
        "joined": "Se unió el {{date}}",
        "barStart": "Empezó el {{date}}",
        "barEnd": "Termina el {{date}}",
        "barEnded": "Terminó el {{date}}",
        "progress": "{{filled}} de {{days}} días contados",
        "extended": "Ampliado {{days}} días",
        "earned": "Ganado",
        "barLabel": "Días de comisión contados de {{name}}",
        "state": {
          "not_paying": "Aún no paga",
          "in_bar": "Generando",
          "bar_done": "Completada",
          "paused_comp": "En pausa (periodo gratis)"
        },
        "source": {
          "link": "Enlace",
          "typed": "Código escrito",
          "operator": "Añadida por Coreway"
        }
      },
      "commissions": {
        "title": "Comisiones",
        "empty": "Todavía no hay comisiones.",
        "paidOn": "Factura pagada el {{date}}",
        "payableOn": "Pagable el {{date}}",
        "base": "Base {{amount}}",
        "kind": {
          "commission": "Comisión",
          "clawback": "Descuento",
          "restore": "Restituida"
        },
        "clawbackReason": "Reembolso de la factura pagada el {{date}}",
        "restoreReason": "Restituida sobre la factura pagada el {{date}}",
        "state": {
          "held": "Retenida",
          "available": "Disponible",
          "paid": "Pagada",
          "reversed": "Anulada"
        }
      },
      "payouts": {
        "title": "Pagos y solicitudes",
        "empty": "Todavía no hay pagos ni solicitudes.",
        "payout": "Pago por {{method}}",
        "paidOn": "Pagado el {{date}}",
        "reference": "Referencia {{reference}}",
        "request": "Solicitud de pago",
        "requestedOn": "Solicitada el {{date}}",
        "rejected": "No aprobada: {{reason}}",
        "method": {
          "ach": "ACH",
          "check": "cheque",
          "wire": "transferencia",
          "zelle": "Zelle",
          "other": "otro medio"
        },
        "status": {
          "pending": "Pendiente de revisión",
          "paid": "Pagada",
          "rejected": "No aprobada"
        }
      },
      "w9": {
        "title": "Formulario fiscal W-9",
        "body": "La ley fiscal de EE. UU. exige un W-9 antes de pagarte. Rellena el formulario del IRS, guárdalo como PDF y súbelo aquí.",
        "blank": "Descarga el W-9 en blanco de irs.gov",
        "choose": "Archivo PDF (máximo 10 MB)",
        "upload": "Subir W-9",
        "uploading": "Subiendo…",
        "uploaded": "W-9 recibido. Lo revisaremos.",
        "status": {
          "none": "Aún no lo has subido",
          "submitted": "En revisión",
          "accepted": "Aceptado",
          "rejected": "No aceptado"
        },
        "submittedOn": "Subido el {{date}}",
        "acceptedOn": "Aceptado el {{date}}",
        "rejectReason": "Motivo: {{reason}}",
        "replace": "Subir un W-9 nuevo"
      },
      "documents": {
        "title": "Documentos firmados",
        "empty": "No hay documentos firmados.",
        "item": "Acuerdo versión {{version}}",
        "signedOn": "Firmado el {{date}}"
      }
    }
  }
}
